export const itemsBaseApiPath = '/api/common/tickets';

import {
  fetchItemsGen,
  deleteItemGen,
  getItemByIdGen,
  editItemGen,
  addItemGen,
  editItemByIdGen
} from '../../../utils/apiHelperGenerators.js';

export const fetchItems = fetchItemsGen(itemsBaseApiPath, 'listItems');
export const deleteItem = deleteItemGen(itemsBaseApiPath);
export const getItemById = getItemByIdGen(itemsBaseApiPath);
export const addItem = addItemGen(itemsBaseApiPath);
export const editItem = editItemGen(itemsBaseApiPath);
export const editItemBy = editItemByIdGen(itemsBaseApiPath);

export default {
  fetchItems,
  deleteItem,
  getItemById,
  addItem,
  editItem,
  editItemBy
};
